import { Drawer } from '@design/components/drawer/Drawer';
import { useChatSettings } from '@terminal/views/alfred/research/use-chat-settings/useChatSettings';
import { useTranslation } from 'react-i18next';

import styles from './PersonalizationDrawer.module.scss';
import { PersonalizationForm } from './PersonalizationForm';

export const PersonalizationDrawer = () => {
  const { t } = useTranslation('chat');

  const { displayPersonalizationDrawer, setDisplayPersonalizationDrawer } =
    useChatSettings(state => ({
      displayPersonalizationDrawer: state.displayPersonalizationDrawer,
      setDisplayPersonalizationDrawer: state.setDisplayPersonalizationDrawer,
    }));

  const closeDrawer = () => {
    setDisplayPersonalizationDrawer(false);
  };

  return (
    <Drawer
      isOpen={displayPersonalizationDrawer}
      handleCloseClick={closeDrawer}
      data-testid="personalization-drawer"
    >
      <div className={styles.container}>
        <h2 className={styles.title}>{t('settings.title')}</h2>
        <div className={styles.content}>
          <div className={styles.description}>{t('settings.subHeader')}</div>
          <PersonalizationForm onCancel={closeDrawer} />
        </div>
      </div>
    </Drawer>
  );
};
